import { create } from 'zustand'

export type PrepRecoveryMode = 'dismissed' | 'used' | 'dismissed_all'

export interface PrepRecoveryState {
  open: boolean
  mode: PrepRecoveryMode
  setOpen: (open: boolean) => void
  toggleOpen: () => void
  setMode: (mode: PrepRecoveryMode) => void
}

const normalizeMode = (mode: unknown): PrepRecoveryMode => {
  if (mode === 'used' || mode === 'dismissed_all') {
    return mode
  }
  return 'dismissed'
}

const usePrepRecoveryStore = create<PrepRecoveryState>((set) => ({
  open: false,
  mode: 'dismissed',
  setOpen: (open) => set(() => ({ open: Boolean(open) })),
  toggleOpen: () => set((state) => ({ open: !state.open })),
  setMode: (mode) => set(() => ({ mode: normalizeMode(mode) })),
}))

export default usePrepRecoveryStore
